import FlightSearch from './FlightSearch';

export default FlightSearch;
